import { BreakpointsOptions } from '@mui/system';

const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 960,
    md: 1128,
    lg: 1600,
    xl: 1920,
  },
};

export default breakpoints;
